<script setup lang="ts">
import { toRefs } from "vue";
import { RouterLink } from "vue-router";
import { utc2local } from "@/utils";
import type { Device } from "@/rvapi";

const props = defineProps<{
  devices: Device[];
  searching: boolean;
}>();

const { devices, searching } = toRefs(props);
</script>

<template>
  <section v-show="!searching && devices.length > 0">
    <h3>Device</h3>
    <pn-table bordered="true" striped="true">
      <table>
        <thead>
          <tr>
            <th>Ref.</th>
            <th>User</th>
            <th>Device</th>
            <th>Last used</th>
            <th>Balance</th>
            <th>Language</th>
            <th>App</th>
            <th>Device</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="device in devices" :key="device.deviceId">
            <td>{{ device.supportRef }}</td>
            <td>
              <RouterLink v-show="device.userId" :to="'/user/' + device.userId">
                {{ device.userId }}
              </RouterLink>
            </td>
            <td>
              <RouterLink :to="'/device/' + device.deviceId">
                {{ device.deviceId?.substring(0, 8) + "..." }}
              </RouterLink>
            </td>
            <td>{{ utc2local(device.lastRegistration) }}</td>
            <td>{{ device.legacyBalance }}</td>
            <td>{{ device.language }}</td>
            <td>{{ device.platform }} {{ device.appVersion }}</td>
            <td>
              {{ device.deviceOsVersion }}
              {{ device.deviceDescription }}
            </td>
          </tr>
        </tbody>
      </table>
    </pn-table>
  </section>
</template>
<style lang="scss" scoped></style>
